module.exports = __webpack_public_path__ + "assets/img/zhencha-9537d6bc.png";